import React, { useRef } from "react";
import { Image as ImageIcon, Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export default function PhotoAttachSplash({ open, onOpenChange, onPhoto }) {
  const libraryRef = useRef(null);
  const cameraRef = useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (file) {
      onPhoto(file);
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl">
        <DialogHeader>
          <DialogTitle>Attach photo</DialogTitle>
          <DialogDescription>Where does the photo originate from?</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-1">
          <Button
            type="button"
            onClick={() => libraryRef.current?.click()}
            className="rounded-xl gap-2 bg-slate-900 hover:bg-slate-800"
          >
            <ImageIcon className="w-4 h-4" /> Photo Library
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => cameraRef.current?.click()}
            className="rounded-xl gap-2"
          >
            <Camera className="w-4 h-4" /> Capture photo
          </Button>
        </div>
        <input
          ref={libraryRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFile}
        />
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          onChange={handleFile}
        />
      </DialogContent>
    </Dialog>
  );
}